import { Field } from 'components/Field'
import { FormFieldProps } from 'components/FormFields'
import { useState } from 'utils'
import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'

export const radioFieldStyles = css`
	.radio-options {
		padding-top: 1em;
	}
	.radio-option {
		display: flex;
		align-items: center;
		padding: 0.6em 0;

		& > label {
			margin-left: 0.5em;
		}
		input {
			width: 25px;
			height: 25px;
			margin: 0;
		}
	}
`

const RadioFieldView = styled.div`
	${radioFieldStyles}
`

export type RadioOption<T> = {
	txt: ReactNode
	val: T
}

export type RadioFieldProps<T> = FormFieldProps & {
	name: string
	onChange?: (val: T) => void
	options: RadioOption<T>[]
	defaultVal?: T
}

export const RadioField = ({
	name,
	options,
	defaultVal,
	onChange,
	className,
	...fieldProps
}: RadioFieldProps<string | number>) => {
	const [value, setValue] = useState(defaultVal, 'value')

	return (
		<RadioFieldView className={`radio-field${className ? ` ${className}` : ''}`}>
			<Field {...fieldProps} name={name}>
				<div className='radio-options'>
					{options.map(({ txt, val }) => (
						<div className='radio-option' key={val}>
							<input
								type='radio'
								name={name}
								value={val}
								onChange={e => {
									const val = e.target.value
									setValue(val)
									if (onChange) onChange(val)
								}}
								id={`${name}-${val}`}
								checked={val === value || val === defaultVal}
							/>
							<label className='radio-option-label' htmlFor={`${name}-${val}`}>
								{txt}
							</label>
						</div>
					))}
				</div>
			</Field>
		</RadioFieldView>
	)
}
